import React, { useState, FC } from 'react';
import { MdSearch } from 'react-icons/md';
import { Styled } from './';
import { useComponentVisible } from 'utils/hooks';
import { useRouter } from 'next/router';
import { useI18n } from 'contexts/i18n';
import SuggestionList from './SuggestionList';
import {
  onFocusHandler,
  handleChange,
  handleKeyPress,
  hideSearchResultsModal,
  label,
} from './SearchField.helper';

const SearchField: FC = () => {
  const router = useRouter();
  const i18n = useI18n();

  const [searchText, setSearchText] = useState('');
  const {
    ref: searchSuggestionRef,
    isComponentVisible: showSearchModal,
    setIsComponentVisible: setShowSearchModal,
  } = useComponentVisible(false);

  // defines the minimum character length to render search results
  const isEnoughCharacters = searchText.length > 1;

  return (
    <>
      <Styled.SearchFieldContainer
        ref={searchSuggestionRef}
        data-testid="search-field"
      >
        <MdSearch size={'24px'} />
        <Styled.SearchInput
          placeholder={label(i18n).placeholder}
          value={searchText}
          // sets input value as state value
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleChange(e, setSearchText)
          }
          // render modal when focusing on the element and setShowSearchModal is true
          onFocus={() => onFocusHandler(setShowSearchModal)}
          // navigates user to the given location
          onKeyPress={(e: React.KeyboardEvent) =>
            handleKeyPress(e, searchText, router)
          }
        />
        {showSearchModal && isEnoughCharacters ? (
          <SuggestionList
            searchText={searchText}
            hideSearchResultsModal={() =>
              hideSearchResultsModal(setShowSearchModal)
            }
          />
        ) : null}
      </Styled.SearchFieldContainer>
    </>
  );
};

export default SearchField;
